import NoResultIcon from '@/common/assets/icons/NoResult-vheicle-part.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import PointsItems from '@/common/components/adjusterReport/damagedPoints/PointsItems';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { Box, Flex } from 'styled-system/jsx';

const LocalDamagedPoints = () => {
  const { removeDamagedPoint, damagedPoints } = useDamagedPoints();
  return (
    <Box
      display="flex"
      minH="30vh"
      maxH="45vh"
      mt={32}
      borderRadius={8}
      border="1px dashed"
      borderColor="gray-1"
      overflow="auto"
      mb="3rem"
    >
      <Flex
        flexDirection="column"
        alignItems={'start'}
        gap={16}
        w="100%"
        p={16}
      >
        <Typography color="purple-1" textStyle="b2">
          لیست نقاط آسیب‌دیده
        </Typography>
        {damagedPoints?.length > 0 ? (
          damagedPoints?.map((item) => (
            <PointsItems
              key={item.id}
              item={item}
              removePoint={() => removeDamagedPoint?.(item)}
              removeAble={true}
            />
          ))
        ) : (
          <EmptySpace />
        )}
      </Flex>
    </Box>
  );
};

export default LocalDamagedPoints;

const EmptySpace = () => {
  return (
    <Box
      w="100%"
      h="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <NoResultIcon />
      <Typography color="black-3" textStyle="b2">
        نقطه ی آسیب‌دیده ای ثبت نشده است.
      </Typography>
    </Box>
  );
};
